import { type ProductInterface } from "@jti/fe-common";

import type { MagentoConfigurableProduct } from "../../types";

export const getDiscount = (data: ProductInterface): number | null => {
  if (!data) {
    return null;
  }

  const {
    price_range: {
      minimum_price: {
        discount: { percent_off: percentOff },
      },
    },
  } = data;

  if (!percentOff) {
    return null;
  }

  return percentOff;
};

export const getDiscountBySKU = (
  currentVariantSku: string,
  { variants }: MagentoConfigurableProduct
): number | null => {
  const product = variants.find((item) => item.product.sku === currentVariantSku);

  if (!product) {
    return null;
  }
  const { percent_off: percentOff } = product.product.price_range.minimum_price.discount;
  return !percentOff ? null : percentOff;
};
